module.exports = __webpack_public_path__ + "assets/images/3d635c01242f032171f4cf7a80f767c6.png";